import React from 'react';
import { useSignalR } from '../../contexts/SignalRContext';
import { useRealtimeState } from '../../realtime/RealtimeProvider';

export default function SignalRStatus() {
  const { status } = useSignalR();
  const realtime = useRealtimeState();
  const sessionMode = realtime.mode === 'session';
  const domainMode = realtime.mode === 'domain';
  const connected = sessionMode ? realtime.status === 'subscribed' : status === 'Connected';
  const domainDetail = realtime.status === 'connected-awaiting-events' ? 'Connected; event delivery not yet verified'
    : realtime.status === 'receiving-domain-events' ? 'Receiving backend updates' : 'Backend connection unavailable';
  const detail = sessionMode || domainMode
    ? realtime.refreshing ? 'Refreshing' : realtime.blocked ? 'Updates deferred while editing or saving'
      : realtime.failed ? 'Refresh failed; retrying' : realtime.pending ? 'Refresh queued' : domainMode ? domainDetail : realtime.status
    : `Pilot: ${status}`;
  const label = `Live updates: ${domainMode && detail !== domainDetail ? `${domainDetail}. ` : ''}${detail}`;
  return <span className="d-inline-flex align-items-center ms-2 px-1" role="status"
    aria-label={label} title={label} tabIndex={0} style={{ color: !connected ? 'red' : realtime.pending || (domainMode && realtime.status !== 'receiving-domain-events') ? '#946200' : 'green', fontSize: '1.25rem' }}>
    <i className={`bi ${connected ? 'bi-link-45deg' : 'bi-link'}`} aria-hidden="true" />
    <span className="visually-hidden">{label}</span>
  </span>;
}
